import { GidInsuranceBundleAll, GidInsuranceBundleListOnly } from '../constants/quote';
import { ANNUAL_FLEXIBLE_KEY, gitBusinessActivityCourier, gitBusinessActivityRemovals, gitBusinessActivityVehicleTransportation, gitBusinessActivityVehicleTransportationAndRemovals } from '../localeConstants/quote';
import { getQuoteCurrentInsuranceInfo } from '../utils/quote';
export var useQuoteGlobalCommonInfo = function useQuoteGlobalCommonInfo() {
  /**
   * Get quote common info: insurer
   * @param quoteInfo
   * @returns
   */
  var getInsurerInfo = function getInsurerInfo(quoteInfo) {
    var _ref = quoteInfo || {},
        insuranceType = _ref.insuranceType,
        providerCode = _ref.providerCode,
        contact = _ref.contact,
        country = _ref.country,
        temporaryUseFormRecruitmentOpenFromValidation = _ref.temporaryUseFormRecruitmentOpenFromValidation; // contact?.country: quote process
    // country: quote detail info


    return getQuoteCurrentInsuranceInfo({
      insuranceType: insuranceType,
      providerCode: providerCode,
      country: (contact === null || contact === void 0 ? void 0 : contact.country) || country,
      temporaryUseFormRecruitmentOpenFromValidation: temporaryUseFormRecruitmentOpenFromValidation
    });
  };
  /**
   * Get cms common info: insurer
   * @param quoteInfo
   * @returns
   */


  var getCmsQuoteInsurerInfo = function getCmsQuoteInsurerInfo(quoteInfo) {
    var _ref2 = quoteInfo || {},
        insuranceType = _ref2.insuranceType,
        providerCode = _ref2.providerCode,
        country = _ref2.country;

    return getQuoteCurrentInsuranceInfo({
      insuranceType: insuranceType,
      providerCode: providerCode,
      country: country
    });
  };
  /**
   * Get quote display cover info
   * @param quoteInfo
   * @param sourceType 1. quote 2. cms
   * @returns
   */


  var getDisplayCoverInfo = function getDisplayCoverInfo(quoteInfo, params) {
    var _quoteInfo$business;

    var _ref3 = params || {},
        _ref3$sourceType = _ref3.sourceType,
        sourceType = _ref3$sourceType === void 0 ? 1 : _ref3$sourceType;

    var info = {};
    var insuranceInfo = getInsurerInfo(quoteInfo);
    var businessActivity = sourceType === 2 ? quoteInfo === null || quoteInfo === void 0 ? void 0 : quoteInfo.businessActivity : quoteInfo === null || quoteInfo === void 0 ? void 0 : (_quoteInfo$business = quoteInfo.business) === null || _quoteInfo$business === void 0 ? void 0 : _quoteInfo$business.businessActivity;
    info.canShowPI = !(insuranceInfo.isGit || insuranceInfo.isGreateAmerican);
    info.canShowPL = !(insuranceInfo.isGit && quoteInfo.insuranceBundle === GidInsuranceBundleListOnly || insuranceInfo.isGreateAmerican);
    info.canShowEL = Boolean(insuranceInfo.isAccelerant || insuranceInfo.isGit && quoteInfo.insuranceBundle === GidInsuranceBundleAll || insuranceInfo.isChubb && (quoteInfo === null || quoteInfo === void 0 ? void 0 : quoteInfo.policyType) === ANNUAL_FLEXIBLE_KEY || insuranceInfo.isRecruitment);
    info.canShowEXL = Boolean(insuranceInfo.isRecruitment || insuranceInfo.isAccelerant);
    info.canShowGIT = insuranceInfo.isGit;
    info.canShowCMR = insuranceInfo.isGit && [gitBusinessActivityCourier, gitBusinessActivityRemovals, gitBusinessActivityVehicleTransportation, gitBusinessActivityVehicleTransportationAndRemovals].includes(businessActivity);
    info.canShowFidelity = Boolean(insuranceInfo.isRecruitment || insuranceInfo.isAccelerant);
    info.canShowDriverNeg = Boolean(insuranceInfo.isRecruitment);
    info.canShowDirectorsOfficers = Boolean(insuranceInfo.isRecruitment || insuranceInfo.isAccelerant);
    info.canShowEmploymentPracticesLiability = Boolean(insuranceInfo.isRecruitment || insuranceInfo.isAccelerant);
    info.canShowPropertyCover = Boolean(insuranceInfo.isRecruitment);
    return info;
  };

  return {
    getInsurerInfo: getInsurerInfo,
    getCmsQuoteInsurerInfo: getCmsQuoteInsurerInfo,
    getDisplayCoverInfo: getDisplayCoverInfo
  };
};